import React, { useState, useEffect } from 'react';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import LoadingPanel from '@/component/common/LoadingPanel';
import { Button, MenuItem, TextField, Tooltip } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { FormProvider } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';

import CustomSchema from '@/schema/CustomSchema';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import localStorageUtil from '@/common/utils/localStorageUtil';

import { corporationAtom } from '@/state/atom/corporationAtom';
import { getUserListByProjectAtom, userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { formListOfProjectSelector } from '@/state/selector/formSelector';
import RenderFieldUI from '../formManagement/RenderFieldUI';
import AssigneeFieldCommonUI from '../formManagement/fieldUI/AssigneeFieldCommonUI';
import {
    closePanelTabSelector,
    triggerReloadTicketListByPanelType,
    updatePanelAfterCreateTicketSelector
} from '@/state/selector/panelSelector';
import InvitationGuestOrGuestCustomer from './InvitationGuestOrGuestCustomer';
import {
    checkIsDisableBtnDraft,
    checkIsDisableBtnSend,
    getOptionSearchLabel,
    submitOnChangeTicketType,
    initDataPanelCreateTicketHelpdeskSide,
    initDataTicketDraftHelpdeskSide,
    onBlurExternalCustomerInput,
    onChangeExternalCustomerInput,
    onClickButtonClose,
    onKeyPressSearchExternalCustomerProject,
    onSubmitCreateTicket,
    onSubmitSaveDraftTicket,
    searchExternalCustomerProject,
    selectExternalCustomerProject
} from './handler/HelpdeskCreateTicketHandler';
import NoticeTicket from './NoticeTicket';
import DelegateTicket from './DelegateTicket';
import TaskTicket from './TaskTicket';
// import EmailTicket from './EmailTicket';
import { DialogConfirmChangeForm } from './addTicketDialog/DialogConfirmChangeForm';
import { DialogConfirmChangeTicketTypeDraftFlow } from './addTicketDialog/DialogConfirmChangeTicketTypeDraftFlow';
import './HelpdeskCreateTicket.css';
import ErrorModal from '../common/modal/ErrorModal';
import { I18n } from 'aws-amplify';
import { DialogConfirmCancelCreateTicket } from './addTicketDialog/DialogConfirmCancelCreateTicket';
import {
    closeTabId,
    multiPanelAtom,
    panelInitDataAtom,
    lastActivePanelIdAtom
} from '@/state/atom/panelAtom';
import { Autocomplete } from '@material-ui/lab';
import { useSnackbar } from 'notistack';
import { DialogConfirmCreateTicketError } from './addTicketDialog/DialogConfirmCreateTicketError';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import { DialogConfirmForceCreateTicket } from './addTicketDialog/DialogConfirmForceCreateTicket';
import {
    getPanelInitData,
    updatePanelInitData
} from '@/component/multiPanel/panel/handler/PanelHandler';
import _, { cloneDeep } from 'lodash';
import { DialogConfirmSoftDeleteTicket } from './listTicketDialog/DialogConfirmSoftDeleteTicket';
import moment from 'moment';
import { submitSoftDeleteTicket } from '../chatThread/handler/DetailTicketHandler';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { checkDetailTicket, deleteAllTicketData } from '@/service/ticketService';
import { DialogConfirmChangeTicketError } from './addTicketDialog/DialogConfirmChangeTicketError';
import { showLoadingMouse, hideLoadingMouse } from '../../common/utils/CustomCursor';
import LinkCorporationInvite from './customerSide/LinkCorporationInvite';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import { isDataInputUrlError } from './handler/KnowledgeTicketHandler';
import { openShareLinkTicket } from '../chatThread/handler/MessageHandler';
import { setPanelSelector } from '@/state/selector/panelSelector';

import { getAssignList } from './handler/TicketListHandler';
import { getProjectMemberList } from './handler/HelpDeskTicketListHandler';
import { getPublicAPI } from '../../service/publicService';
import { getProjectOfEmailResponseSetting } from '@/component/project/handler/ProjectProfileManagementHandler';
import { handleOnchangeFormDelegateAndTask } from './handler/DelegateTicketHandler';
import { getEmailFormOfProject } from '../../service/formManagementService';
import TicketBookmark from '../ticketKnowledge/elements/Bookmark/TicketBookmark';

export default function HelpdeskCreateTicket(props) {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingFormList, setIsLoadingFormList] = useState(true);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [currentPanelInitData, setCurrentPanelInitData] = useState({});
    const lastActivePanelId = useRecoilValue(lastActivePanelIdAtom);
    const [isInitOldData, setIsInitOldData] = useState(false);
    const [onChangeEdit, setOnChangeEdit] = useState(false);

    const corporationId = localStorageUtil.getAffiliationOrganization();

    // common userDetail state
    const [userDetail, setUserDetail] = useRecoilState(userAtom);

    // common corporationDetail state
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);

    // common projectInuse state
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);

    // common form
    const [currentCorporationFormList, setCurrentCorporationFormList] = useRecoilState(
        formListOfProjectSelector
    );
    const [formList, setFormList] = useState([]);
    const [selectedForm, setSelectedForm] = useState('');
    const [listFieldEdited, setListFieldEdited] = useState([]);

    const [fieldListData, setFiledListData] = useState([]);

    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUpdatedList, setFileUpdatedList] = useState([]);
    const [selectedFormInfo, setSelectedFormInfo] = useState({});
    const [autoFillObject, setAutoFillObject] = useState({});

    const [fileUploading, setFileUploading] = useState([]);
    const [isModalUploadFileError, setIsModalUploadFileError] = useState(false);

    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [isEdited, setIsEdited] = useState(false);
    const [triggerSaveFormData, setTriggerSaveFormData] = useState('');
    const [triggerSaveStateData, setTriggerSaveStateData] = useState('');

    const validateCreateTicket = useForm({
        mode: 'all',
        shouldUnregister: true,
        defaultValues: {
            outline: '',
            category: '',
            description: '',
            field_qa_category: []
        },
        resolver: yupResolver(CustomSchema(fieldListData))
    });
    const handleSubmitCreateTicket = validateCreateTicket.handleSubmit;
    const errorCreateTicket = validateCreateTicket.errors;
    const clearErrors = validateCreateTicket.clearErrors;
    const setValueCreateTicket = validateCreateTicket.setValue;
    const registerCreateTicket = validateCreateTicket.register;
    const unregisterCreateTicket = validateCreateTicket.unregister;
    const getValuesCreateTicket = validateCreateTicket.getValues;
    const resetValuesCreateTicket = validateCreateTicket.reset;
    const setErrorCreateTicket = validateCreateTicket.setError;
    const [isExChangeTagField, setIsExChangeTagField] = useState(false);
    const [selectTicketType, setSelectTicketType] = useState();
    const [createTicketType, setCreateTicketType] = useState();
    const [createTicketTypeSelectTemp, setCreateTicketTypeSelectTemp] = useState();

    const [selectedFormChange, setSelectedFormChange] = useState('');
    const [isOpenSelectForm, setIsOpenSelectForm] = useState(false);
    const [isOpenSelectTicketType, setIsOpenSelectTicketType] = useState(false);

    const [isConfirmChangeForm, setIsConfirmChangeForm] = useState(false);
    const [isConfirmChangeTicketType, setIsConfirmChangeTicketType] = useState(false);

    const [isDisableButtonSend, setIsDisableButtonSend] = useState(true);
    const [isDisableButtonDraft, setIsDisableButtonDraft] = useState(true);
    const [isConfirmCancelCreateTicket, setIsConfirmCancelCreateTicket] = useState(false);

    // State for Delegate ticket
    const [guestProjectList, setGuestProjectList] = useState([]);
    const [guestUserListByProject, setGuestUserListByProject] = useState([]);
    const [guestUserSelected, setGuestUserSelected] = useState({});
    const [guestProjectSelected, setGuestProjectSelected] = useState({});

    // State for ticket notice
    const [methodNotice, setMethodNotice] = useState(0);
    const [generalProjectList, setGeneralProjectList] = useState([]);
    const [baseProjectUserList, setBaseProjectUserList] = useState([]);
    const [listCustomerUser, setListCustomerUser] = useState([]); // Customer user of prj
    const [listExternalCustomerProject, setListExternalCustomerProject] = useState([]); // B2B customer of prj
    const [noticeCustomerList, setNoticeCustomerList] = useState([]); // All customer of prj (user/prj)
    const [noticeCustomer, setNoticeCustomer] = useState(''); // Customer for notice

    const [isCanNotSendTicketWhenDeskOnPublicOff, setIsCanNotSendTicketWhenDeskOnPublicOff] = useState(false);

    const listOptionsNoticeMultiCustomer = [
        {
            id: Constant.NOTICE_GROUP_CUSTOMER.ALL_CUSTOMER_PROJECT,
            name: 'カスタマープロジェクト',
            value: Constant.NOTICE_ALL_CUSTOMER.ALL_CUSTOMER_PROJECT
        },
        {
            id: Constant.NOTICE_GROUP_CUSTOMER.ALL_GUEST_CUSTOMER_USER,
            name: 'ゲストカスタマーユーザー',
            value: Constant.NOTICE_ALL_CUSTOMER.ALL_GUEST_CUSTOMER_USER
        },
        {
            id: Constant.NOTICE_GROUP_CUSTOMER.ALL_GENERAL_PROJECT,
            name: '組織内プロジェクト',
            value: Constant.NOTICE_ALL_CUSTOMER.ALL_GENERAL_PROJECT
        },
        {
            id: Constant.NOTICE_GROUP_CUSTOMER.ALL_USER_IN_BASE_PROJECT,
            name: '組織内ユーザー',
            value: Constant.NOTICE_ALL_CUSTOMER.ALL_USER_IN_BASE_PROJECT
        }
    ];

    // State for external customer request ticket
    const [externalCustomerProjectList, setExternalCustomerProjectList] = useState([]);
    const [externalCustomerRequestKeyword, setExternalCustomerRequestKeyword] = useState('');
    const [externalCustomerRequestProject, setExternalCustomerRequestProject] = useState({});
    const [openExternalCustomerList, setOpenExternalCustomerList] = useState(true);
    const [externalCustomerProjectErr, setExternalCustomerProjectErr] = useState({
        error: false,
        helperText: ''
    });
    const [isOpenPopupCreateTicketError, setIsOpenPopupCreateTicketError] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [errorCreateTicketMsgCode, setErrorCreateTicketMsgCode] = useState('');
    const [isOpenModalConfirmForceCreateTicket, setIsOpenModalConfirmForceCreateTicket] = useState(
        false
    );
    const [isLoadingInitData, setIsLoadingInitData] = useState(false);

    const [isOpenPopupSoftDelete, setIsOpenPopupSoftDelete] = useState(false);
    const [detailTicket, setDetailTicket] = useState(props.detailTicket);

    // const getPermissionCreateInviteGuestProject = currentProject => {
    //     return Utils.isPublicDesk(currentProject);
    // };
    const isDraftMode = props?.detailTicket?.public === Constant.TICKET_PUBLIC.DRAFT
        ? true : false;
    
    const [isSoftDelete, setIsSoftDelete] = useState(false);
    const [isShowDialogRestoreTicket, setIsShowDialogRestoreTicket] = useState(false);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const [isConfirmDialogObj, setIsConfirmDialogObj] = useState(false);
    const [isOpenPopupTicketMsg, setIsOpenPopupTicketMsg] = useState(false);
    const [isOpenPopupTicketError, setIsOpenPopupTicketError] = useState(false);
    const [isHelpDesk, setIsHelpDesk] = useState(false);
    const currentUserDetail = useRecoilValue(userAtom);
    const isGeneralUserWithGuest = Utils.isGeneralUser(currentUserDetail);
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: I18n.get('MSG-CM-DELETED-CONTENT'),
        confirmTxt: I18n.get('CM-BUTTON-OK')
    });
    const addNewPanel = useSetRecoilState(setPanelSelector);

    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenNotFoundTicketPopup, setIsOpenNotFoundTicketPopup] = useState(false);

    // Task ticket
    const [selectedAssigneeUserId, setSelectedAssigneeUserId] = useState('');
    const userListRecoilValue = useRecoilValue(getUserListByProjectAtom);
    const [assignList, setAssignList] = useState([]);
    const [statusNo, setStatusNo] = useState(0);

    // Email ticket.
    const [toEmailAddressList, setToEmailAddressList] = useState([]);
    const [ccEmailAddressList, setCcEmailAddressList] = useState([]);
    const [bccEmailAddressList, setBccEmailAddressList] = useState([]);
    const [listSuggestSearchEmail, setListSuggestSearchEmail] = useState([]);

    useEffect(() => {
        (async () => {
            // Init assignee list
            if (createTicketType === Constant.TICKET_TYPE.TASK) {
                let currentProjectMemberList = await getProjectMemberList(
                    userListRecoilValue
                );
    
                const listAssign = getAssignList(currentProjectMemberList, currentUserDetail);
                setAssignList([...listAssign]);
    
                const initAssigneeUserId = props?.detailTicket?.personInCharge || '';
                if (listAssign.some(user => user.id === initAssigneeUserId)) {
                    setSelectedAssigneeUserId(initAssigneeUserId);
                } else {
                    setSelectedAssigneeUserId('');
                }

                let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
                let lastFormOfProject = workLastForm[projectInuseDetail.id];
                if (lastFormOfProject) {
                    let lastFormTaskOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_TASK];
                    if (!Utils.isEmptyObject(lastFormTaskOfProject))
                        setSelectedForm(lastFormTaskOfProject.formId);
                }
            }
            if (createTicketType === Constant.TICKET_TYPE.NOTICE) {
                if (isDraftMode) {
                    const { NOTICE_GROUP_CUSTOMER, NOTICE_METHOD } = Constant;
                    const currentCustomer = props?.detailTicket?.customer;

                    const initMethodNotice = Object.values(NOTICE_GROUP_CUSTOMER).includes(currentCustomer)
                        ? NOTICE_METHOD.MULTIPLE
                        : NOTICE_METHOD.SINGLE;

                    setMethodNotice(initMethodNotice);
                } else {
                    let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
                    let lastFormOfProject = workLastForm[projectInuseDetail.id];
                    if (lastFormOfProject) {
                        let lastFormNotiOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_NOTICE];
                        if (
                            !Utils.isEmptyObject(lastFormNotiOfProject) && [
                                Constant.NOTICE_ALL_CUSTOMER.ALL_CUSTOMER_PROJECT,
                                Constant.NOTICE_ALL_CUSTOMER.ALL_GUEST_CUSTOMER_USER,
                                Constant.NOTICE_ALL_CUSTOMER.ALL_GENERAL_PROJECT,
                                Constant.NOTICE_ALL_CUSTOMER.ALL_USER_IN_BASE_PROJECT
                            ].includes(lastFormNotiOfProject?.method)
                        ) {
                            setMethodNotice(Constant.NOTICE_METHOD.MULTIPLE);
                        } else {
                            setMethodNotice(Constant.NOTICE_METHOD.SINGLE);
                        }
                    }
                }
            }
            if (
                [
                    Constant.TICKET_INVITATION_GUEST
                ].includes(createTicketType)
            ) {
                let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
                let lastFormOfProject = workLastForm[projectInuseDetail.id];
                if (lastFormOfProject) {
                    let lastFormInviteOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_INVITED];
                    if (!Utils.isEmptyObject(lastFormInviteOfProject))
                        setSelectedForm(lastFormInviteOfProject.formId);
                }
            }

            if (
                createTicketType === Constant.TICKET_TYPE.EMAIL
            ) {
                setIsLoadingInitData(true);
                let paramsGetEmailSetting = {
                    getApiType: Constant.GET_API_PUBLIC_TYPE.GET_PROJECT_EMAIL_SETTING,
                    projectId: projectInuseDetail.id,
                    corporationId: corporationDetail.id,
                    sugguestProjectMail: true
                };

                const [currentProjectMemberList, emailSettingData, emailFormDetail] = await Promise.all([
                    getProjectMemberList(userListRecoilValue),
                    getPublicAPI(props?.API, paramsGetEmailSetting),
                    getEmailFormOfProject(corporationDetail.id, projectInuseDetail.id, currentCorporationFormList)
                ]);

                const listAssign = getAssignList(currentProjectMemberList, currentUserDetail);
                setAssignList([...listAssign]);

                const initAssigneeUserId = props?.detailTicket?.personInCharge || '';
                if (listAssign.some(user => user.id === initAssigneeUserId)) {
                    setSelectedAssigneeUserId(initAssigneeUserId);
                } else {
                    setSelectedAssigneeUserId('');
                }

                if (emailSettingData.success) {
                    const { projectDetail, suggestList } = Utils.convertJSONDataToObject(
                        emailSettingData.payload
                    );

                    const {
                        ccEmailAddressList: getCcEmailAddressList,
                        bccEmailAddressList: getBccEmailAddressList,
                    } = getProjectOfEmailResponseSetting(projectDetail, corporationDetail)

                    setCcEmailAddressList(getCcEmailAddressList)
                    setBccEmailAddressList(getBccEmailAddressList)

                    setListSuggestSearchEmail([...suggestList]);
                }

                if (isDraftMode) {
                    let fieldList = Utils.convertJSONDataToObject(argsAll.draftData.fieldListData);
                    let listToEmailAddress = fieldList.find(item => item.sysField === Constant.SYS_FIELD.TO)?.value || [];
                    let CcEmailAddress = fieldList.find(item => item.sysField === Constant.SYS_FIELD.CC)?.value || [];
                    let BccEmailAddress = fieldList.find(item => item.sysField === Constant.SYS_FIELD.BCC)?.value || [];
  
                    setToEmailAddressList(listToEmailAddress);
                    setCcEmailAddressList(CcEmailAddress);
                    setBccEmailAddressList(BccEmailAddress);
                }
                
                let emailFormId = emailFormDetail?.id;

                if (emailFormId) {
                    setSelectedForm(emailFormId);
                    let e = {
                        target: {
                            value: emailFormId
                        }
                    }
                    await handleOnchangeFormDelegateAndTask(e, {
                        ...argsAll,
                        typeOfTicket: Constant.TICKET_TYPE.EMAIL
                    })
                }
                setIsLoadingInitData(false);
            }
        })();
    }, [createTicketType, currentCorporationFormList, projectInuseDetail]);

    const onClickUrlViewTicket = async url => {
        setIsLoading(true);
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            props?.API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            userDetail.id,
            projectInuseDetail.id,
            {
                ...props,
                setIsLoading,
                API: props?.API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setProjectInuseDetail,
                userDetail: userDetail,
                setUserDetail: setUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    };

    const argsAll = {
        ...props,
        isLoading,
        setIsLoading,
        isLoadingInitData,
        setIsLoadingInitData,
        closePanelTab,
        panelList,
        setPanelList,
        panelInitData,
        setPanelInitData,
        currentPanelInitData,
        setCurrentPanelInitData,
        lastActivePanelId,
        isInitOldData,
        setIsInitOldData,

        API: props?.API,
        corporationId,
        userDetail,
        corporationDetail,
        setCorporationDetail,
        projectInuseDetail,
        currentCorporationFormList,
        setCurrentCorporationFormList,

        fieldListData,
        setFiledListData,
        selectedFormInfo,
        setSelectedFormInfo,
        createTicketType,
        setCreateTicketType,
        selectTicketType,
        setSelectTicketType,
        createTicketTypeSelectTemp,
        setCreateTicketTypeSelectTemp,

        validateCreateTicket,
        errorCreateTicket,
        clearErrors,
        setValueCreateTicket,
        registerCreateTicket,
        unregisterCreateTicket,
        getValuesCreateTicket,
        resetValuesCreateTicket,
        setErrorCreateTicket,

        updatePanelAfterCreateTicket: useSetRecoilState(updatePanelAfterCreateTicketSelector),
        formList,
        setFormList,
        selectedForm,
        setSelectedForm,

        selectedFormChange,
        setSelectedFormChange,
        isOpenSelectForm,
        setIsOpenSelectForm,
        isOpenSelectTicketType,
        setIsOpenSelectTicketType,
        isConfirmChangeForm,
        setIsConfirmChangeForm,
        isConfirmChangeTicketType,
        setIsConfirmChangeTicketType,
        isDisableButtonSend,
        setIsDisableButtonSend,
        isDisableButtonDraft,
        setIsDisableButtonDraft,
        isConfirmCancelCreateTicket,
        setIsConfirmCancelCreateTicket,

        fileUploading,
        setFileUploading,
        isModalUploadFileError,
        setIsModalUploadFileError,

        guestProjectList,
        setGuestProjectList,
        guestUserListByProject,
        setGuestUserListByProject,
        guestUserSelected,
        setGuestUserSelected,
        guestProjectSelected,
        setGuestProjectSelected,

        fileUploadList,
        setFileUploadList,

        externalCustomerProjectList,
        setExternalCustomerProjectList,
        externalCustomerRequestKeyword,
        setExternalCustomerRequestKeyword,
        externalCustomerRequestProject,
        setExternalCustomerRequestProject,
        openExternalCustomerList,
        setOpenExternalCustomerList,
        externalCustomerProjectErr,
        setExternalCustomerProjectErr,
        enqueueSnackbar,
        isOpenPopupCreateTicketError,
        setIsOpenPopupCreateTicketError,
        isOpenModalReloadPage,
        setIsOpenModalReloadPage,
        errorCreateTicketMsgCode,
        setErrorCreateTicketMsgCode,
        isOpenModalConfirmForceCreateTicket,
        setIsOpenModalConfirmForceCreateTicket,
        isDraftMode,
        triggerSaveFormData,
        setTriggerSaveFormData,
        fileUpdatedList,
        setFileUpdatedList,
        triggerSaveStateData,
        setTriggerSaveStateData,
        isEdited,
        setIsEdited,
        updatePanelInitData,
        methodNotice,
        setMethodNotice,
        generalProjectList,
        setGeneralProjectList,
        baseProjectUserList,
        setBaseProjectUserList,
        listCustomerUser,
        setListCustomerUser,
        listExternalCustomerProject,
        setListExternalCustomerProject,
        noticeCustomerList,
        setNoticeCustomerList,
        noticeCustomer,
        setNoticeCustomer,
        listOptionsNoticeMultiCustomer,

        isHelpDesk,
        detailTicket,
        setLastUserAction,
        selectedAssigneeUserId,
        setSelectedAssigneeUserId,
        setUserDetail,

        statusNo,
        setStatusNo,
        toEmailAddressList,
        setToEmailAddressList,
        ccEmailAddressList,
        setCcEmailAddressList,
        bccEmailAddressList,
        setBccEmailAddressList,

        setIsCanNotSendTicketWhenDeskOnPublicOff
    };

    useEffect(() => {
        setIsDisableButtonSend(checkIsDisableBtnSend(argsAll));
        setIsDisableButtonDraft(checkIsDisableBtnDraft(argsAll));
    });

    useEffect(() => {
        updatePanelInitData(
            props.panelId,
            props.tabId,
            panelInitData,
            setPanelInitData,
            'isEditedData',
            isEdited
        );
    }, [isEdited]);

    useEffect(() => {
        resetValuesCreateTicket();
        registerCreateTicket('fileUploadList');
        registerCreateTicket('attachments');
        registerCreateTicket('selectedForm');

        if (isDraftMode) {
            initDataTicketDraftHelpdeskSide(argsAll);
        } else {
            let currentPanelInitDataRes = getPanelInitData(props.panelId, props.tabId, panelInitData);
            if (currentPanelInitDataRes && !Utils.isEmptyObject(currentPanelInitDataRes) && !Utils.isEmptyArray(currentCorporationFormList)) {
                setCurrentPanelInitData(currentPanelInitDataRes);
                if (currentPanelInitDataRes.argsAll) {
                    setIsLoadingInitData(true);
                    initDataPanelCreateTicketHelpdeskSide(currentPanelInitDataRes, argsAll)
                        .then(result => {
                        })
                        .catch(error => {
                            console.log('initDataPanelCreateTicketHelpdeskSide error :>> ', error);
                        })
                        .finally(() => {
                            setIsLoadingInitData(false);
                            setIsLoading(false)
                        });
                }
            }
        }

        if(!isDraftMode) submitOnChangeTicketType(props?.selectedTicketType, argsAll);

        setIsSoftDelete(!Utils.isEmptyString(detailTicket?.deletedAt));
        setIsHelpDesk(detailTicket?.affiliationProject === projectInuseDetail.id);
        if (props?.selectedTicketType) {
            setSelectTicketType(props?.selectedTicketType);
        }
    }, [currentCorporationFormList]);

    // Update panelInitDataAtom
    useEffect(() => {
        setValueCreateTicket('corporationOrigin', guestProjectSelected?.affiliationOrganization);
        let newArgsAll = cloneDeep(argsAll);
        delete newArgsAll.panelInitData;
        delete newArgsAll.currentPanelInitData;
        updatePanelInitData(
            props.panelId,
            props.tabId,
            panelInitData,
            setPanelInitData,
            'argsAll',
            newArgsAll
        );

        if (!Utils.isEmptyArray(currentCorporationFormList)) {
            setIsLoadingFormList(false);
        }
    }, [
        selectTicketType,
        guestProjectSelected,
        guestUserSelected,
        methodNotice,
        noticeCustomer,
        noticeCustomerList,
        selectedForm,
        externalCustomerRequestProject,
        fileUploadList,
        fileUploading,
        fileUpdatedList,
        triggerSaveStateData,
        currentCorporationFormList,
        selectedAssigneeUserId,
        statusNo,
        toEmailAddressList,
        ccEmailAddressList,
        bccEmailAddressList
    ]);

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (isEdited) {
                setIsConfirmCancelCreateTicket(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        if (
            (lastActivePanelId &&
                lastActivePanelId.panelId === props.panelId &&
                lastActivePanelId.tabId === props.tabId) ||
            triggerSaveFormData
        ) {
            let formData = getValuesCreateTicket();
            if (!Utils.isEmptyArray(fieldListData)) {
                let fieldAttachments = fieldListData.find(
                    field => field.sysField === 'attachments'
                );
                if (!Utils.isEmptyObject(fieldAttachments)) {
                    let defaultFileUpload = [];
                    if (!Utils.isEmptyArray(fileUpdatedList)) {
                        defaultFileUpload = fileUpdatedList.filter(file => !file.isDelete);
                    } else if (!Utils.isEmptyArray(fieldAttachments.defaultValue)) {
                        defaultFileUpload = fieldAttachments.defaultValue;
                    } else if (!Utils.isEmptyArray(fieldAttachments.value)) {
                        defaultFileUpload = fieldAttachments.value;
                    }
                    formData[fieldAttachments.id] = defaultFileUpload;
                    formData['fileUploadList'] = defaultFileUpload;
                }
            }
            updatePanelInitData(
                props.panelId,
                props.tabId,
                panelInitData,
                setPanelInitData,
                'formData',
                formData
            );
        }
    }, [lastActivePanelId, triggerSaveFormData]);

    useEffect(() => {
        if (isLoading || isLoadingInitData) {
            showLoadingMouse();
        } else {
            hideLoadingMouse();
        }
    }, [isLoading, isLoadingInitData]);

    useEffect(() => {
        const panelHelpdeskTicketList = panelList.filter(panel =>
            [
                Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
                Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
            ].includes(panel.type)
        );
        let newPanelList = _.cloneDeep(panelList);
        panelHelpdeskTicketList?.forEach(panelHelpdeskTicket => {
            let tabDeletedHelpdeskTicket = panelHelpdeskTicket.tabList?.map(tab =>
                tab.id === detailTicket?.id
                    ? {
                          ...tab,
                          isTicketDeleted: !Utils.isEmptyString(detailTicket.deletedAt)
                              ? true
                              : false
                      }
                    : tab
            );
            const newPanelHelpdeskTicket = {
                ...panelHelpdeskTicket,
                tabList: tabDeletedHelpdeskTicket
            };
            newPanelList = newPanelList.map(panel =>
                panel.type === panelHelpdeskTicket.type ? (panel = newPanelHelpdeskTicket) : panel
            );
        });

        setPanelList(newPanelList);
    }, [isSoftDelete]);

    const handleSubmitSaveDraft = () => {
        let formData = getValuesCreateTicket();
        let isExistUrlError = isDataInputUrlError(fieldListData, errorCreateTicket);
        if (isExistUrlError) {
            return;
        }
        return onSubmitSaveDraftTicket(formData, argsAll);
    };

    const onSubmitForceCreateTicket = () => {
        let formData = getValuesCreateTicket();
        let forceCreate = true;
        return onSubmitCreateTicket(formData, argsAll, forceCreate);
    };

    const handleSoftDeleteTicket = () => {
        setIsOpenPopupSoftDelete(true);
    };

    const getPanelType = () => {
        let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, panelList);
        if (currentPanelIndex === -1) return '';
        let currentPanel = panelList[currentPanelIndex];
        return currentPanel.type;
    };

    const getTicketListType = () => {
        return getPanelType() === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
            ? Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
            : Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
    };

    const submitSoftDelete = async () => {
        const deletedAt = isSoftDelete ? null : new Date().toISOString();
        setIsLoading(true);
        if (isSoftDelete) {
            setIsShowDialogRestoreTicket(false);
        }

        let result = await submitSoftDeleteTicket(
            props?.API,
            detailTicket,
            deletedAt,
            currentUserDetail,
            argsAll
        );
        if (result?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            setIsLoading(false);
            setIsOpenModalReloadPage(true);
            return;
        }
        setIsLoading(false);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });

        setDetailTicket({ ...detailTicket, deletedAt });

        if (isSoftDelete) {
            enqueueSnackbar(I18n.get('MSG-CM-RESTORE-CONTENT-SUCCESSFULLY'), {
                variant: 'success',
                autoHideDuration: 3000
            });
            setIsSoftDelete(false);
        } else {
            enqueueSnackbar(I18n.get('MSG-CM-DELETE-CONTENT-SUCCESSFULLY'), {
                variant: 'success',
                autoHideDuration: 3000
            });
            setIsSoftDelete(true);
        }
    };

    const handleDeleteTicket = async () => {
        setIsLoading(true);
        let ticketId = detailTicket.id;
        let currentStatusTicket = await checkDetailTicket(props?.API, ticketId);
        if (currentStatusTicket.status === Constant.TICKET_DELETED_STATUS.REMOVED) {
            setIsLoading(false);
            setIsOpenPopupTicketError(true);
            return;
        }
        if (currentStatusTicket.status === Constant.TICKET_DELETED_STATUS.INUSED) {
            setIsLoading(false);
            setIsOpenPopupTicketMsg(true);
            return;
        }

        let removeOldTicket = await deleteAllTicketData(props?.API, {
            ticketId: ticketId
        });
        setIsLoading(false);
        if (!removeOldTicket) {
            enqueueSnackbar(I18n.get('COMMSG002'), {
                variant: 'error',
                autoHideDuration: 3000
            });
            return;
        }

        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
        });
        closePanelTab({
            event: null,
            panelType: getPanelType(),
            panelId: props.panelId,
            tabId: props.tabId
        });
        closePanelTab({
            event: null,
            panelType:
                props.ticketListType === 'helpdesk'
                    ? Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
                    : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD,
            panelId: props.panelId,
            tabId: props.tabId
        });
        enqueueSnackbar(I18n.get('MSG-CM-COMPLETE-DELETE-CONTENT-SUCCESSFULLY'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    };

    const onClickCloseConfirmDialog = () => {
        setIsShowDialogRestoreTicket(false);
        setIsConfirmDialogObj(false);
    };

    const onClickOkConfirmDialog = async () => {
        setIsConfirmDialogObj(false);
        await handleDeleteTicket();
    };

    const defaultSubdomainInvited = detailTicket?.invitationInfo?.subDomainInvited || '';

    const renderBtnCompletedDeleteAndRestoreTicket = () => {
        if (isSoftDelete && isGeneralUserWithGuest) {
            return (
                <>
                    <Button
                        className="btn-send btn-delete btn-hg32"
                        variant="contained"
                        color="primary"
                        onClick={() => setIsConfirmDialogObj(true)}
                    >
                        完全削除
                    </Button>
                    <Button
                        className="btn-send btn-outline-primary btn-hg32"
                        variant="contained"
                        color="primary"
                        onClick={() => setIsShowDialogRestoreTicket(true)}
                    >
                        復元
                    </Button>
                </>
            );
        }
    };

    const buttonSubmitAddTicket = () => {
        return (
            <div className="col2">
                <div className="itemAddticket btn-addTicket-container">
                    <div className="wrap-btn-add">
                        {!isSoftDelete && (
                            <>
                                {/* <Button
                                    className="btn-send btn-light btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => onClickButtonClose(argsAll)}
                                >
                                    キャンセル
                                </Button> */}


                                {isDraftMode && (
                                    <Button
                                        className="btn-send btn-delete btn-hg32"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSoftDeleteTicket}
                                    >
                                        削除
                                    </Button>
                                )}

                                {/* {
                                    createTicketType !== Constant.TICKET_TYPE.EMAIL && */}
                                    <Button
                                        className="btn-send btn-outline-primary btn-hg32"
                                        variant="contained"
                                        color="primary"
                                        disabled={isDisableButtonDraft}
                                        onClick={handleSubmitSaveDraft}
                                    >
                                        下書き保存
                                    </Button>
                                {/* } */}

                                <Button
                                    className="btn-send btn-primary btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    disabled={isDisableButtonSend}
                                    onClick={handleSubmitCreateTicket(data =>
                                        onSubmitCreateTicket(data, argsAll)
                                    )}
                                >
                                    {createTicketType ===
                                    Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT
                                        ? I18n.get('USER03BTN011')
                                        : I18n.get('USER04BTN001')}
                                </Button>
                            </>
                        )}
                        {renderBtnCompletedDeleteAndRestoreTicket()}
                    </div>
                </div>
            </div>
        );
    };

    const handleReloadComponent = () => {
        setExternalCustomerProjectList([]);
        setExternalCustomerRequestKeyword('');
        setExternalCustomerRequestProject({});
        setOpenExternalCustomerList(true);
        setExternalCustomerProjectErr({
            error: false,
            helperText: ''
        });
    };

    const onSelectNewAssign = newAssignee => {
        if (Utils.isEmptyArray(newAssignee)) {
            return;
        }

        if (newAssignee[newAssignee.length - 1] != undefined) {
            if (Utils.isEmptyString(newAssignee[newAssignee.length - 1]?.id)) {
                return;
            }
        }

        const newValue = Utils.isEmptyArray(newAssignee)
            ? []
            : [newAssignee[newAssignee.length - 1]];
        if (!Utils.isEmptyArray(newValue)) {
            setSelectedAssigneeUserId(newValue[0].id);
            setIsEdited(true);
        }
    };

    return (
        <div className="groupCreate-main ">
            <LoadingPanel isLoading={isLoading || isLoadingInitData || isLoadingFormList} />
            {buttonSubmitAddTicket()}

            {isSoftDelete && (
                <div className="form-addTicket">
                    <div className="alert-complete-delete-ticket">
                        <p>
                            本チケットは削除した日付から30日以内で復元可能です。
                            <br />
                            {moment(detailTicket.deletedAt)
                                .add(30, 'days')
                                .format('YYYY/MM/DD')}
                            に自動的に完全削除されます。
                        </p>
                    </div>
                </div>
            )}

            {(detailTicket && !props.isDuplicate) && (
                <div className='ticket-knowledge-options-container'>
                    <TicketBookmark
                        isViewDelete={!Utils.isEmptyString(detailTicket.deletedAt)}
                        ticketKnowledge={detailTicket} 
                        setIsOpenModalReloadPage={setIsOpenModalReloadPage} 
                        panelType={Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL}
                    />
                </div>
            )}

            <div className="scrollBar-main">
                <div className="addTicket addTicketHelpdesk">
                    <FormProvider {...validateCreateTicket}>
                        {/* display when user not select ticket type */}
                        {(!selectTicketType || selectTicketType === '') && (
                            <div className="form-addTicket form-addTicket-helpdesk-create">
                                <label className="form-addTicket-label">フォーマット</label>
                                <div
                                    className="form-addTicket-input"
                                    data-cy="qa-ticket-select-form"
                                >
                                    <TextField
                                        className="form-control form-control--wrap form-control--hg40"
                                        select
                                        variant="outlined"
                                        name="selectedForm"
                                        SelectProps={{
                                            MenuProps: {
                                                anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'left'
                                                },
                                                getContentAnchorEl: null,
                                                className: 'selectDrop'
                                            }
                                        }}
                                        disabled={!Utils.isEmptyString(detailTicket?.deletedAt)}
                                    >
                                        <MenuItem style={{ display: 'none' }}></MenuItem>
                                    </TextField>
                                </div>
                            </div>
                        )}

                        {[
                            Constant.HELPDESK_CREATE_TICKET_TYPE.NOTICE,
                            Constant.TICKET_TYPE.BROADCAST_PARENT,
                            Constant.TICKET_TYPE.BROADCAST_CHILD
                        ].includes(selectTicketType) && <NoticeTicket {...argsAll} />}

                        {selectTicketType === Constant.HELPDESK_CREATE_TICKET_TYPE.DELEGATE && (
                            <DelegateTicket {...argsAll} />
                        )}

                        {selectTicketType === Constant.HELPDESK_CREATE_TICKET_TYPE.TASK && (
                            <TaskTicket {...argsAll} />
                        )}

                        {/* {selectTicketType === Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL && (
                            <EmailTicket {...argsAll} />
                        )} */}

                        {selectTicketType ===
                            Constant.HELPDESK_CREATE_TICKET_TYPE.INVITATION_GUEST && (
                            <InvitationGuestOrGuestCustomer {...argsAll} />
                        )}

                        {createTicketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER && (
                            <div className="form-addTicket form-addTicket-helpdesk-create">
                                <label className="form-addTicket-label">
                                    申請先カスタマー<span className="required">*</span>
                                </label>
                                <div className="form-addTicket-input external-desk-input">
                                    <Autocomplete
                                        freeSolo
                                        open={openExternalCustomerList}
                                        onOpen={e => setOpenExternalCustomerList(true)}
                                        onClose={() => setOpenExternalCustomerList(false)}
                                        forcePopupIcon={true}
                                        popupIcon={
                                            <SearchIcon
                                                onClick={e =>
                                                    searchExternalCustomerProject(
                                                        argsAll,
                                                        externalCustomerRequestKeyword
                                                    )
                                                }
                                            />
                                        }
                                        sx={{
                                            maxHeight: 10
                                        }}
                                        options={externalCustomerProjectList}
                                        renderOption={option => (
                                            <Tooltip
                                                title={getOptionSearchLabel(
                                                    option,
                                                    externalCustomerRequestKeyword
                                                )}
                                            >
                                                <span
                                                    style={{
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                >
                                                    {getOptionSearchLabel(
                                                        option,
                                                        externalCustomerRequestKeyword
                                                    )}
                                                </span>
                                            </Tooltip>
                                        )}
                                        getOptionLabel={option =>
                                            getOptionSearchLabel(
                                                option,
                                                externalCustomerRequestKeyword
                                            )
                                        }
                                        disableClearable
                                        getOptionSelected={(option, selectedValue) =>
                                            option.title === selectedValue.title &&
                                            option.value === selectedValue.value
                                        }
                                        value={externalCustomerRequestProject}
                                        onChange={(e, newValue) =>
                                            selectExternalCustomerProject(argsAll, newValue)
                                        }
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                name="externalCustomerRequestProject"
                                                variant="outlined"
                                                className="form-control form-control-wrapInput form-control-hg40"
                                                placeholder="キーワードを入力してください"
                                                onChange={e =>
                                                    onChangeExternalCustomerInput(e, argsAll)
                                                }
                                                onBlur={e =>
                                                    onBlurExternalCustomerInput(e, argsAll)
                                                }
                                                value={externalCustomerRequestKeyword}
                                                defaultValue={externalCustomerRequestKeyword}
                                                required
                                                error={externalCustomerProjectErr.error}
                                                helperText={externalCustomerProjectErr.helperText}
                                            />
                                        )}
                                        filterOptions={(options, object) => options}
                                        onKeyPress={e =>
                                            onKeyPressSearchExternalCustomerProject(
                                                e,
                                                argsAll,
                                                externalCustomerRequestKeyword
                                            )
                                        }
                                        disabled={!Utils.isEmptyString(detailTicket?.deletedAt)}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="form-helpdesk-create">
                            {!Utils.isEmptyArray(fieldListData) &&
                                fieldListData
                                    ?.filter(field => {
                                        if (
                                            [Constant.HELPDESK_CREATE_TICKET_TYPE.TASK, Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL].includes(selectTicketType) ||
                                            (detailTicket && [Constant.TICKET_TYPE.TASK, Constant.TICKET_TYPE.EMAIL].includes(detailTicket.ticketType) && detailTicket.public === Constant.TICKET_PUBLIC.DRAFT)
                                        ) {
                                            return true
                                        }
                                        return field.type !== 'WORKFLOW'
                                    })
                                    .map((fieldData, i) => {
                                        if (
                                            ( [Constant.HELPDESK_CREATE_TICKET_TYPE.TASK, Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL].includes(selectTicketType) ||
                                                !Utils.isEmptyObject(argsAll.draftData)) &&
                                            fieldData.sysField === 'personInCharge'
                                        ) {
                                            return (
                                                <AssigneeFieldCommonUI
                                                    key={fieldData.fieldId}
                                                    assignList={assignList}
                                                    onSelectNewAssign={onSelectNewAssign}
                                                    fieldId={fieldData.id}
                                                    isShowIconCopyFieldId={false}
                                                    disable={
                                                        !Utils.isEmptyString(
                                                            detailTicket?.deletedAt
                                                        )
                                                    }
                                                    uniqueId={`${props.panelId}-${props.tabId}-${fieldData.id}-common`}
                                                    selectedAssignee={selectedAssigneeUserId}
                                                />
                                            );
                                        }

                                        return (
                                            <RenderFieldUI
                                                API={props?.API}
                                                UI={fieldData.structure.UI}
                                                label={
                                                    fieldData.fieldLabel
                                                        ? Utils.getTextByLanguage(
                                                              Constant.LANGUAGE_TYPE.JP,
                                                              fieldData.fieldLabel
                                                          )
                                                        : ''
                                                }
                                                errorlist={errorCreateTicket}
                                                name={fieldData.fieldId}
                                                data={fieldData}
                                                defaultValue={
                                                    currentPanelInitData.formData &&
                                                    currentPanelInitData.formData[fieldData.fieldId]
                                                        ? currentPanelInitData.formData[
                                                              fieldData.fieldId
                                                          ]
                                                        : null
                                                }
                                                key={fieldData.fieldId}
                                                // Drop file props
                                                fileUploadList={fileUploadList}
                                                setFileUploadList={setFileUploadList}
                                                register={registerCreateTicket}
                                                setValue={setValueCreateTicket}
                                                getValues={getValuesCreateTicket}
                                                clearErrors={clearErrors}
                                                parentForm={selectedFormInfo}
                                                autoFillObject={autoFillObject}
                                                setAutoFillObject={setAutoFillObject}
                                                isEdited={isEdited}
                                                setIsEdited={setIsEdited}
                                                isExChangeTagField={isExChangeTagField}
                                                setIsExChangeTagField={setIsExChangeTagField}
                                                listFieldEdited={listFieldEdited}
                                                setListFieldEdited={setListFieldEdited}
                                                setFileUpdatedList={setFileUpdatedList}
                                                fileUpdatedList={fileUpdatedList}
                                                editTicket={isDraftMode}
                                                setOnChangeEdit={setOnChangeEdit}
                                                onChangeEdit={onChangeEdit}
                                                panelId={props.panelId}
                                                panelList={panelList}
                                                detailTicket={detailTicket}
                                                isSoftDelete={isSoftDelete}
                                                isDraft={
                                                    Utils.isEmptyObject(argsAll.draftData)
                                                        ? false
                                                        : true
                                                }
                                                ticketType={createTicketType}
                                                isLoading={isLoading}
                                                setIsLoading={setIsLoading}
                                                isShowIconCopyFieldId={false}
                                                onClickUrlViewTicket={onClickUrlViewTicket}
                                                
                                                selectTicketType={selectTicketType}
                                                selectedAssigneeUserId={selectedAssigneeUserId}
                                                statusDetail={
                                                    (detailTicket && [Constant.TICKET_TYPE.TASK, Constant.TICKET_TYPE.EMAIL].includes(detailTicket.ticketType))
                                                    ? Utils.convertJSONDataToObject(detailTicket?.statusDetail) : {}
                                                }
                                                fieldData={fieldData}
                                                setFiledListData={setFiledListData}
                                                currentPanelInitData={currentPanelInitData}
                                                setStatusNo={setStatusNo}
                                                toEmailAddressList={toEmailAddressList}
                                                setToEmailAddressList={setToEmailAddressList}
                                                ccEmailAddressList={ccEmailAddressList}
                                                setCcEmailAddressList={setCcEmailAddressList}
                                                bccEmailAddressList={bccEmailAddressList}
                                                setBccEmailAddressList={setBccEmailAddressList}
                                                listSuggestSearchEmail={listSuggestSearchEmail}
                                                panelType={Constant.PANEL_TYPE.ADD_TICKET}
                                                setErrorCreateTicket={setErrorCreateTicket}
                                            />
                                        );
                                    })}
                            {createTicketType === Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT && (
                                <LinkCorporationInvite
                                    setValue={setValueCreateTicket}
                                    getValues={getValuesCreateTicket}
                                    clearErrors={clearErrors}
                                    errorlist={errorCreateTicket}
                                    setErrorCreateTicket={setErrorCreateTicket}
                                    // defaultSubdomainInvited={defaultSubdomainInvited}
                                    defaultSubdomainInvited={
                                        currentPanelInitData.formData &&
                                        currentPanelInitData.formData['subDomainInvited']
                                            ? currentPanelInitData.formData['subDomainInvited']
                                            : defaultSubdomainInvited
                                    }
                                    disabled={isLoading}
                                    ticketType={createTicketType}
                                    setIsEdited={setIsEdited}
                                    register={registerCreateTicket}
                                />
                            )}
                        </div>
                    </FormProvider>
                </div>
            </div>

            <DialogConfirmChangeForm {...argsAll} isHelpDesk={true} isQA={false} />
            <DialogConfirmChangeTicketTypeDraftFlow {...argsAll} isHelpDesk={true} isQA={false} />
            <DialogConfirmCancelCreateTicket
                {...argsAll}
                onClickSaveDraft={handleSubmitSaveDraft}
                handleSubmitSentDraft={handleSubmitCreateTicket(data =>
                    onSubmitCreateTicket(data, argsAll)
                )}
                isDisableButtonSend={isDisableButtonSend}
                setErrorCreateTicket={setErrorCreateTicket}
                getValuesCreateTicket={getValuesCreateTicket}
                fieldListData={fieldListData}
            />
            <DialogConfirmCreateTicketError
                {...argsAll}
                isOpen={isOpenPopupCreateTicketError}
                setIsOpen={setIsOpenPopupCreateTicketError}
                onSubmit={handleReloadComponent}
            />
            <DataChangePleaseReloadModal
                {...argsAll}
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <DialogConfirmForceCreateTicket
                {...argsAll}
                isOpen={isOpenModalConfirmForceCreateTicket}
                setIsOpen={setIsOpenModalConfirmForceCreateTicket}
                onSubmit={onSubmitForceCreateTicket}
            />

            <DialogConfirmSoftDeleteTicket
                isOpen={isOpenPopupSoftDelete}
                setIsOpen={setIsOpenPopupSoftDelete}
                submitSoftDelete={submitSoftDelete}
                detailTicket={props.detailTicket}
            />
            <ConfirmDialog
                isOpen={isShowDialogRestoreTicket}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-RESTORE-CONTENT')}
                closeCallBack={onClickCloseConfirmDialog}
                okCallBack={submitSoftDelete}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isConfirmDialogObj}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-COMPLETELY')}
                closeCallBack={onClickCloseConfirmDialog}
                okCallBack={onClickOkConfirmDialog}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenPopupTicketError}
                okCallBack={handleReloadComponent}
                msgConfirm={I18n.get('COMMSG068')}
                textSubmit={I18n.get('COMBTN006')}
            />
            <DialogConfirmChangeTicketError {...argsAll} isOpen={isOpenPopupTicketMsg} />

            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={I18n.get('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={'はい'}
            />
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={e => setIsOpenAccessDeniedPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={I18n.get('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />
            <ConfirmDialog
                isOpen={isCanNotSendTicketWhenDeskOnPublicOff}
                msgConfirm={I18n.get('MSG-CM-NO-PERMISSION-TO-PERFORM-REQUEST')}
                okCallBack={() => setIsCanNotSendTicketWhenDeskOnPublicOff(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            {/* Error upload file */}
            <ErrorModal
                open={isModalUploadFileError}
                message={`${fileUploading?.file?.name} ${I18n.get('USER04MSG004')}`}
                handleCloseDialog={() => setIsModalUploadFileError(false)}
                title={'Upload fail'}
            ></ErrorModal>
        </div>
    );
}
